import { ResponseInfo } from './http';

export type ErrorMessage = {
    id?: string,
    message?: string,
    errors?: ErrorMessage[]
};

export default class HTTPError extends Error {

    constructor(
        public response: ResponseInfo<ErrorMessage>
    ) {
        super(`HTTP Error: ${response.status}`);
    }

}
